import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { DefaultWebsocketClient, WebsocketClientClass } from '../modules/websocket/module';

export class LinearDeterminate extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.loadingLineFn = this.loadingLineFn.bind(this);
    }
    public state: State = {
        show: false,
        progress: 0,
        uid: false
    }
    //
    listener: WebsocketClientClass | null = null;
    // 进度条进度
    timer: NodeJS.Timeout | null = null;

    // *********************
    // Life Cycle Function
    // *********************
    componentDidMount() {
        this.init();
    }
    componentWillUnmount() {
        this.timer && clearInterval(this.timer);
        this.listener?.removeListener('LOADING_LINE', this.loadingLineFn);
        this.timer = null;
        this.listener = null;
    }
    // *********************
    // Default Function
    // *********************

    init() {
        this.listener = DefaultWebsocketClient?.on('LOADING_LINE', this.loadingLineFn);
    }

    /**
     * 执行加载动画
     * @param action 是否执行
     * @param value 执行的值
     */
    loadingLineFn(action: boolean, value: boolean) {
        if (action) {
            if (value === true) {
                const t = setTimeout(() => {
                    // 每次有新的进度，从0开始
                    this.setState({ show: true, progress: 0 }, () => {
                        this.timer && clearInterval(this.timer);
                        this.timer = setInterval(() => {
                            const oldProgress = this.state.progress;
                            const diff = Math.random() * 15;
                            this.setState({
                                progress: Math.min(oldProgress + diff, 98)
                            });
                        }, 150);
                    });
                    clearTimeout(t);
                },
                    // 等待上次进度条完成时400ms动画
                    this.state.progress === 100 ? 400 : 0
                );
            } else if (value === false) {
                this.timer && clearInterval(this.timer);
                this.setState({ progress: 100 }, () => {
                    const t = setTimeout(() => {
                        this.setState({ show: false, progress: 0 });
                        clearTimeout(t);
                    }, 400);
                });
            }
            DefaultWebsocketClient.emit('LOADING_LINE', false, value);
        }
    }

    // *********************
    // View
    // *********************

    render() {
        return (
            <div
                className='linearBar'
                style={{
                    width: '100%',
                    zIndex: 112,
                    position: 'fixed',
                }}>
                {this.state.show && <LinearProgress variant='determinate' value={this.state.progress} />}
            </div>
        );
    }
}

// *********************
// State & Props
// *********************

type State = { show: boolean; progress: number; uid: string | false }

type Props = {}

/**
 * 开启/关闭顶部线性进度（与 RBP2 `setLinearLoading` 命名对齐，供打印等迁入页使用）。
 */
export function setLinearLoading(value: boolean) {
    DefaultWebsocketClient.emit('LOADING_LINE', true, value);
}

/** 默认导出：云 RBP 子功能页沿用 `import setLoading from ...` */
export default setLinearLoading;